import { render, staticRenderFns } from "./MenuDropdown.vue?vue&type=template&id=e968d274"
import script from "./MenuDropdown.vue?vue&type=script&lang=ts"
export * from "./MenuDropdown.vue?vue&type=script&lang=ts"
import style0 from "./MenuDropdown.vue?vue&type=style&index=0&id=e968d274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports